import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from '../../../api.service';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent {
    forgotForm: FormGroup;
    isLoading = false;
    successSent = false;

    constructor(
        private fb: FormBuilder,
        private apiService: ApiService,
        private toastr: ToastrService,
    ) {
        this.forgotForm = this.fb.group({
            email: ['', [Validators.required, Validators.email]],
        });
    }

    onSubmit(): void {
        if (this.forgotForm.invalid) {
            this.forgotForm.markAllAsTouched();
            return;
        }

        this.isLoading = true;
        const email = this.forgotForm.value.email;

        this.apiService
            .apiPost('recuperar_clave', false, { email }, 2)
            .then(
                (response: any) => {
                    this.isLoading = false;
                    this.successSent = true;
                },
                (error: any) => {
                    this.isLoading = false;
                    // Mostrar éxito igualmente para no revelar si el correo existe
                    this.successSent = true;
                }
            );
    }
}
